/**
 * Renders a short inline preview for FAQ or TXT documents inside table rows,
 * using `metadata.preview`. When `preview` is missing, renders nothing.
 *
 */
export const FAQAnswer = ({
  preview,
}: {
  collection_id: string;
  datasource_id: string;
  document_id: string;
  preview?: string;
}) => {
  if (!preview) {
    return null;
  }

  return (
    <div className="line-clamp-3 truncate text-sm leading-tight text-wrap text-muted-foreground">
      {preview}
    </div>
  );
};
